/// <amd-module name="Wiki/ProjectOverview/WikiProjectAboutService" />
import * as React from "react";

import { Services, VssService } from "VSS/Platform/Context";

import { IProjectAboutRegionProvider } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Components/AboutProject/PanelAboutRegion/Interfaces";
import { WikiAboutRegion } from "Wiki/ProjectOverview/WikiAboutRegion";
import * as Resources from "Wiki/ProjectOverview/Resources";

class WikiProjectAboutService extends VssService implements IProjectAboutRegionProvider {
    public getAboutRegion(
        readMode: boolean,
        repoId: string | undefined,
        repoIdChanged: (repoId: string) => void,
        markTimeToInteractive: (source: string) => void,
        showError: boolean
    ): JSX.Element {
        return (
            <WikiAboutRegion
                readMode={readMode}
                repoId={repoId}
                onRepositoryChanged={repoIdChanged}
                markTimeToInteractive={markTimeToInteractive}
                showError={showError}
            />
        );
    }

    public getChoiceName(): string {
        return Resources.WikiLabel;
    }
}

Services.add("Wiki.ProjectAboutService", { serviceFactory: WikiProjectAboutService });
